import {
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Grid,
  useMediaQuery
} from '@mui/material';
import DescriptionIcon from '@mui/icons-material/Description';
import { useTheme } from '@mui/material/styles';

export default function DetailDialog({ open, onClose, detailData }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const detailDataList = detailData?.map((item, index) => {
    const detail = {
      md: 6,
      sx: {},
      component: (
        <Typography
          variant="subtitle2"
          sx={{ paddingLeft: '1rem' }}
          color="text.secondary"
        >
          {item.value}
        </Typography>
      )
    }

    if (Array.isArray(item.value)) {
      detail.md = 12
      detail.sx.alignItems = 'start'
      detail.sx.flexDirection = 'column'
      detail.component = item.value.map((value, index) => (
        <Typography
          variant="subtitle2"
          sx={{ paddingLeft: '1rem' }}
          key={`sub-value-${index}`}
          color="text.secondary"
        >
          {value}
        </Typography>)
      )
    }

    if (isMobile) {
      detail.md = 12
    }

    return (
      <Grid item xs={12} md={detail.md} key={`value-${index}`}>
        <Box sx={detail.sx}>
          <Typography variant="subtitle2" sx={{ textAlign: 'left' }} color="text.primary">
            {item.label} :
          </Typography>
          {detail.component}
        </Box>
      </Grid>
    )
  })

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ style: { minWidth: 'auto', maxWidth: 'auto' } }}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', backgroundColor: '#fafafa' }}>
        <Typography variant="h6" sx={{ textAlign: 'left' }} fontWeight="bold">
          รายละเอียดเพิ่มเติม
        </Typography>

        <DescriptionIcon color="primary" sx={{ ml: 1 }} />
      </DialogTitle>
      <DialogContent>
        <Grid container rowSpacing={2} columnSpacing={5}  padding={2}>
          {detailDataList}
        </Grid>
      </DialogContent>
      <DialogActions style={{ backgroundColor: '#fafafa' }}>
        <Button onClick={onClose} color='error'>ปิด</Button>
      </DialogActions>
    </Dialog>
  );
}
